import React, { memo, useMemo } from 'react';
import AiSpeakerAvatar from './ai-speaker-avatar';

/**
 * @prop speaker - it will give who is messaging user or saleshandy-copilot.
 * @prop firstName - it will show firstName of user.
 * @prop lastName - it will show lastName of user.
 *
 * @returns React Component
 */
const AiSpeakerName: React.FC<{
  speaker: string;
  firstName?: string;
  lastName?: string;
}> = ({ speaker = 'saleshandy-copilot', firstName = '', lastName = '' }) => {
  // ** Memoized Values
  const isUser = useMemo(() => speaker === 'user', [speaker]);

  const name = useMemo(() => {
    if (isUser) {
      return `${firstName || ''} ${lastName || ''}`;
    }
    return 'AI Sequence Copilot';
  }, [isUser, firstName, lastName]);

  return (
    <div className={`ai-speaker-name-container ${isUser ? 'user' : ''}`}>
      <AiSpeakerAvatar
        speaker={speaker}
        firstName={firstName}
        lastName={lastName}
      />
      <span className="ai-speaker-name-text">{name}</span>
    </div>
  );
};

export default memo(AiSpeakerName);
